import { Tooltip } from "@mui/material";
import * as React from "react";


const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
  <Tooltip title="show scorecard with success status" arrow>
    <span>
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <g opacity={1} fill={fill}>
      <path d="M14.72 22.156c-3.857 0-7-3.128-7-6.985s3.143-6.972 7-6.972 7 3.129 7 6.986c0 3.857-3.143 6.971-7 6.971Zm0-13.228c-3.457 0-6.257 2.8-6.257 6.243a6.265 6.265 0 0 0 12.529 0c0-3.457-2.815-6.243-6.272-6.243Z" />
      <path d="m14.32 17.799-2.629-2.415.5-.543 2.015 1.843 2.914-4.243.614.429-3.414 4.929Z" />
    </g>
  </svg>
  </span>
  </Tooltip>
);

export default SvgComponent;